import React, { useState, useEffect, createContext, useContext } from "react";
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { MY_PAGE_ORDER_COUNT_URL } from "../../utils/urls";
import instance from "../../services/services";
import { useLanguage } from "../../hooks/useLanguage";

// Context 생성
const OrderCountContext = createContext();

// Context를 사용하는 커스텀 훅
export const useOrderCount = () => {
  const context = useContext(OrderCountContext);
  if (!context) {
    throw new Error('useOrderCount must be used within OrderCountProvider');
  }
  return context;
};

function OrderView(){
  const { t } = useLanguage();
  const [tabActive, setTabActive] = useState('visit');
  const navigate = useNavigate();
  const location = useLocation();
  const [orderCount, setOrderCount] = useState({
    visit: 0,
    parcel: 0,
    sale: 0
  });

  const handleClickTab = (tab) => {
    setTabActive(tab);
    navigate(`/order/${tab}`);
  };

  // 주문 개수 조회 함수
  const fetchOrderCount = async () => {
    try {  
      const response = await instance.post(MY_PAGE_ORDER_COUNT_URL);
      setOrderCount(response.data.data);
    } catch (error) {
      console.error("데이터 가져오기 실패:", error);
    }
  };

  useEffect(() => {
    fetchOrderCount();
  }, []);

  // URL변화 감지해서 탭 상태 맞추기
  useEffect(() => {
    const path = location.pathname.split('/').pop();
    if (path && ['visit', 'parcel', 'sale'].includes(path)) {
      setTabActive(path);
    }
  }, [location]);

  // Context 값 정의
  const contextValue = {
    orderCount,
    refreshOrderCount: fetchOrderCount
  };

  return(
    <OrderCountContext.Provider value={contextValue}>
      <div>
        <div className="order_page">
          <div className="tab_line">
            <div className="order_tab">
              <ul> 
                <li 
                  className={tabActive === 'visit' ? 'active' : ''}
                  onClick={() => handleClickTab('visit')}
                >
                  {t("in_store_order")}<span>{orderCount?.visit || 0}</span>
                </li>
                <li
                  className={tabActive === 'parcel' ? 'active' : ''}
                  onClick={() => handleClickTab('parcel')}
                >
                  {t("delivery_order")}<span>{orderCount?.parcel || 0}</span>
                </li>            
                <li
                  className={tabActive === 'sale' ? 'active' : ''}
                  onClick={() => handleClickTab('sale')}
                >
                  {t("order_sales_product")}<span>{orderCount?.sale || 0}</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Outlet 사용 → Router가 히스토리 관리 */}
          <Outlet />
        </div>
      </div>
    </OrderCountContext.Provider>
  );
}

export default OrderView;